// extracted by mini-css-extract-plugin
export default {"miniMapModal":"map_modal__miniMapModal--KrGM","mapModalWrapper":"map_modal__mapModalWrapper--tpAT","map":"map_modal__map--7gcg"};